import ChangeHeaderTitleMessage from '@/Messages/ChangeHeaderTitleMessage';
import ComponentManager from '@/Management/ComponentManager';
import type ModalDetailViewContext from '@/Components/ModalDetailView/ModalDetailViewContext';

export default class ModalChangeHeaderTitleMessage extends ChangeHeaderTitleMessage {

    /**
     * @override
     */
    public context: ModalDetailViewContext;

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('ModalChangeHeaderTitleMessage', ModalChangeHeaderTitleMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');